import { PostServiceM3 } from "../../ConexionSQL/posts.service";
//import { sessionWE8 } from "../../../Session/session.class";
import { Filtros } from "../Maestro/filtros";
import { M3CouchMaestro } from "../Data/m3-couch-maestro";
import { TypeM3PrdGrp } from "../Maestro/M3PrdGrp.type";
import { M3Ubicacion } from "../Maestro/Ubicacion/M3Ubicacion.type";
import { ServiceListaPrecio } from "./m3-lista-precio.service";
import { ServiceLoadListaPrecio } from "./m3-load-l-precio.service";
import * as _ from "lodash";
import { Optional } from "@angular/core";
import { Éµangular_packages_platform_browser_platform_browser_a } from "@angular/platform-browser";
import { M3Procesos } from "../Registro/m3-procesos";

export class ServiceM3Maestro {


    constructor() { }

    //Trae el m3procesos segpun el idprestamo
    public getM3ProcesosPorCredito(PostServiceM3: PostServiceM3, sIDKatios: string, idProceso: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        var data;
        data = { 'idProceso': idProceso }
        PostServiceM3.getWithBodyM3('M3/getM3ProcesosPorCredito/' + sIDKatios, data).subscribe(resp => {

            oFuncionOK(JSON.parse(resp.toString()));
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }//End 

    //Trae el m3procesos segpun el idprestamo
    public getM3ProcesoByIdPrestamo(PostServiceM3: PostServiceM3, sIDKatios: string, sIdPrestamo: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3/getM3ProcesoByIdPrestamo/' + sIDKatios + '/' + sIdPrestamo).subscribe(resp => {
            var oM3Procesos: any;
            oM3Procesos = resp;

            oFuncionOK(oM3Procesos);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err);
            });
    }//End 

    //rae el TIPO, SKP1, NOMBRE de la tabla prdgrp
    public m3GetPRDGRP(PostServiceM3: PostServiceM3, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/getM3PRDGRP/' + sIDKatios).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            var oData = JSON.parse(resp);

            oFuncionOK(oData);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err);
            });
    }//End 


    //Obtener la cantidad disponible de producto, teniendo en cuenta el SKP1 y la ubicaciÃ³n.
    //La data debe tener una estructura: {"UBICACION":"1111", "SKP1":"9999a"}
    public M3GetCantidadBySKP1(PostServiceM3: PostServiceM3, sIDKatios: string, oDataSend: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3Maestro/M3GetCantidadBySKP1/' + sIDKatios, oDataSend).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            var oData = JSON.parse(resp.toString());
            var goDataDisp: Array<any>;
            if (oData.RESPUESTA.DISPONIBILIDAD.length === undefined) {
                //No es array
                goDataDisp = new Array<any>(oData.RESPUESTA.DISPONIBILIDAD);
            } else {
                goDataDisp = oData.RESPUESTA.DISPONIBILIDAD;
            }
            console.log(goDataDisp);
            oFuncionOK(goDataDisp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }//End 



    //Obtener la lista de producto, teniendo en cuenta, un array de filtros.
    GetListaPrdXFiltros(PostServiceM3: PostServiceM3, olFiltros: Array<Filtros>, sIDLista: string, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function, @Optional() idUbicacion = "-1", @Optional() aplUltimoFiltro = true) {
        var oDataSend;
        oDataSend = { "Filtros": JSON.stringify(olFiltros), "IdLista": sIDLista, "IdUbicacion": idUbicacion, "aplUltimoFiltro": aplUltimoFiltro };
        if (olFiltros != null) {
            PostServiceM3.getWithBodyM3('M3Maestro/Get_ListPRDFiltros/' + sIDKatios, oDataSend).subscribe(resp => {
                //Ejecutar funcion de procesamiento OK
                oFuncionOK(resp, olFiltros);
            },
                err => {
                    //Ejecutar funcion de error
                    oFuncionErr(err.error.Message);
                });
        } else {
            oFuncionErr("No hay filtros para la busqueda");
        }
    }


    //Obtener lista de productos, segun la categoria.
    GetListaPrdXCategoria(PostServiceM3: PostServiceM3, sCategoria: string, oDataClasificacion, IdLista: string, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function, @Optional() idUbicacion = "-1") {
        var olFiltros: Array<Filtros>;
        var oDataSend;
        olFiltros = this.FindFilterInClasificacion(sCategoria, sIDKatios, oDataClasificacion);

        oDataSend = { "Filtros": JSON.stringify(olFiltros), "IdLista": IdLista, "IdUbicacion": idUbicacion };
        if (olFiltros != null) {
            PostServiceM3.getWithBodyM3('M3Maestro/Get_ListPRDFiltros/' + sIDKatios, oDataSend).subscribe(resp => {
                //Ejecutar funcion de procesamiento OK
                oFuncionOK(resp, olFiltros);
            },
                err => {
                    //Ejecutar funcion de error
                    console.log(err.error.Message);
                    oFuncionErr(err.error.Message);
                });
        } else {
            oFuncionErr("No hay filtros para la busqueda");
        }

    }//End GetListaPrdXCategoria





    //Obtener lista de productos, segun la categoria.
    GetListaPrdXCategoriaWithOutFilters(PostServiceM3: PostServiceM3, sCategoria: string, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getM3('M3Maestro/M3GetListaProdByClasificacion/' + sIDKatios + '/' + sCategoria).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp, null);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err);
            });
    }//End GetListaPrdXCategoria



    //Obtener lista de productos, segun el nombre o descripciÃ³n.
    GetListaPrdXNombre(PostServiceM3: PostServiceM3, sNombre: string, idUbicacion: string, sIDKatios: string, sIDLista: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        var oData = { "IdLista": sIDLista, "idUbicacion": idUbicacion };
        PostServiceM3.getWithBodyM3('M3Maestro/M3GetListaProdByNombre/' + sIDKatios + '/' + sNombre, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                console.log(err);
                //Ejecutar funcion de error
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }

    cargarListPrdByGeneric(PostServiceM3: PostServiceM3, sNombre: string, idUbicacion: string, sIDKatios: string, sIDLista: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        var oData = { "IdLista": sIDLista, "idUbicacion": idUbicacion };
        PostServiceM3.getWithBodyM3('M3Maestro/cargarListPrdByGeneric/' + sIDKatios + '/' + sNombre, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                console.log(err.error);
                //Ejecutar funcion de error
                oFuncionErr(err.error);
            });
    }

    //cargar informacion de clasificacion
    cargarInfoClasificacion(PostServiceM3: PostServiceM3, sIDKatios: string, jsonResp,
        oFuncionOK: Function, oFuncionErr: Function) {

        //var osessionWE8 = new sessionWE8();

        //jsonResp = osessionWE8.GetDataCLASIFICACION(sIDKatios);
        if (jsonResp === undefined || jsonResp == null) {
            PostServiceM3.getM3("M3Maestro/M3GetClasificacion/" + sIDKatios).subscribe(resp => {
                jsonResp = JSON.parse(resp);
                this.ValidarArrayClasificacion(jsonResp);
                //osessionWE8.SetDataCLASIFICACION(jsonResp, sIDKatios);
                //Ejecutar funcion de procesamiento OK
                oFuncionOK(jsonResp);
            },
                error => {
                    //Ejecutar funcion de error
                    oFuncionErr(error);
                });
        } else {
            oFuncionOK(jsonResp);
        }
    }//End cargarInfoClasificacion

    //Validar que la clasificacion, esten como array.
    ValidarArrayClasificacion(oDataClas) {
        this.RecursiveConvertArray(oDataClas.RESPUESTA.CLASIFICACIONES);
    }


    //Aplicar filtros a la categoria entrante.
    FindFilterInClasificacion(sClasFind: string, sIDKatios: string, oDataClasificacion) {
        var sClasificacion: string = "";
        var oDataFiltrada;
        //var osessionWE8 = new sessionWE8();
        var olFiltros = new Array<Filtros>();
        var oFiltros: Filtros;
        var filtroAtributo: string;

        //console.log(sClasFind);
        //oDataClasificacion = osessionWE8.GetDataCLASIFICACION(sIDKatios);

        oDataFiltrada = oDataClasificacion.RESPUESTA.CLASIFICACIONES;

        if (sClasFind.length % 3 == 0) {
            while (sClasFind != "") {

                sClasificacion = sClasificacion + sClasFind.substring(0, 3);
                sClasFind = sClasFind.substring(3);
                oDataFiltrada = oDataFiltrada.CATEGORIA.find(filtro => filtro.CLASIFICACION.toString() == sClasificacion.toString());

                filtroAtributo = oDataFiltrada.ATRIBUTO;
                if (!filtroAtributo.toUpperCase().includes("ROOT")) {
                    oFiltros = new Filtros(oDataFiltrada.ATRIBUTO, oDataFiltrada.Descripcion);
                    olFiltros.push(oFiltros);
                }


                //oDataRespCla = this.RecursiveClasificacion(oDataClasificacion.RESPUESTA.CLASIFICACIONES.CATEGORIA, sClasFind);
                //console.log(oDataRespCla);
            }
        } else {
            return null;
        }
        return olFiltros;
    }

    //Recursividad, para validar que todos los nodos, sean tipo array
    RecursiveConvertArray(oDataClas) {
        if (oDataClas.CATEGORIA !== undefined) {
            if (oDataClas.CATEGORIA.length === undefined) {
                oDataClas.CATEGORIA = new Array(oDataClas.CATEGORIA);
                this.RecursiveConvertArray(oDataClas.CATEGORIA[0]);
            } else {
                oDataClas.CATEGORIA.forEach(clas => {
                    this.RecursiveConvertArray(clas);
                });
            }
        }
    }

    //Adiciona un producto
    m3AddProducto(PostServiceM3: PostServiceM3, sIDKatios: string, tdocUActivo: string, ndocUActivo: string, oM3PrdGrp: TypeM3PrdGrp, oFuncionOK: Function, oFuncionErr: Function, disabledWeb: boolean = false) {
        var data;
        data = { 'sTdocUsuario': tdocUActivo, 'sNdocUsuario': ndocUActivo, 'oM3PrdGrp': oM3PrdGrp, 'disabledWeb': disabledWeb };

        PostServiceM3.postServiceHttpResFullM3("M3Maestro/addProducto/" + sIDKatios.trim(), data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            error => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }

    //Obtener producto por SKP1.
    M3GetProductoBySKP1(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function, oDataUser: any) {
        PostServiceM3.getWithBodyM3("M3Maestro/M3GetProductoBySKP1/" + sIDKatios, data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var producto: any = resp;
            var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(sIDKatios);
            oServiceLoadListaPrecio.AsignarListaPrecio(producto, oDataUser, PostServiceM3).then(x => {
                oFuncionOK(producto);
            });

        },
            error => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }
    //Obtener producto random por SKP1.
    M3GetProductoRandomBySKP1(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function, oDataUser: any) {
        PostServiceM3.getWithBodyM3("M3Maestro/M3GetProductoRandomBySKP1/" + sIDKatios, data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            error => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }


    ///Get Imagenes enviando en la oData: {"Path":"xxx", "SKU":"SKUxxx"}
    public M3GetImagenesByPath(PostServiceM3: PostServiceM3, sIDKatios: string, oData: any, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3Maestro/Get_M3MultimediaByPath/' + sIDKatios, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(err.error.Message);
            });
    }

    //obtener informacion de plantillas, desde servidor... 
    Get_M3SKPlantillaBySKUID(PostServiceM3: PostServiceM3, sIDKatios: string, SKUID: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3("M3Maestro/Get_M3SKPlantillaBySKUID/" + sIDKatios + "/" + SKUID).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            oFuncionOK(resp);
        },
            error => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }

    //Obtener informaciÃ³n de productos, desde codigo de barras
    GetInfoByFilterCode(PostServiceM3: PostServiceM3, sIDKatios: string, sFilterCode: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        var oData = { "FILTERCODE": sFilterCode };

        PostServiceM3.getWithBodyM3('M3Maestro/M3GetSKP1PrdsByFiltersCode/' + sIDKatios, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(JSON.parse(resp.toString()));
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(err.error.Message);
            });
    }//End GetInfoByFilterCode 

    //Obtiene el objeto M3Ubicaciones para la ubicacion y idkatios dados
    get_M3Ubicaciones(PostServiceM3: PostServiceM3, sIDKatios: string, sIdUbicacion: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getM3('M3Maestro/get_M3Ubicaciones/' + sIDKatios + '/' + sIdUbicacion).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(err);
            });
    }//End get_M3Ubicaciones

    //Obtiene el objeto M3Ubicaciones para la ubicacion y idkatios dados
    get_M3UbicacionesCompleta(PostServiceM3: PostServiceM3, sIDKatios: string, sIdUbicacion: string, sIdHub: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3WithTimeOut('M3Maestro/get_M3UbicacionesCompleta/' + sIDKatios + '/' + sIdUbicacion + '/' + sIdHub, 10000).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(err);
            });
    }//End get_M3UbicacionesCompleta


    //rae el producto de acuerdo al SKU
    public M3GetProductoBySKU(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function, oDataUser: any) {
        var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(sIDKatios);

        if (oDataUser.UsuarioSistema.FechaPrecio) data.fechaLPrecio = oDataUser.UsuarioSistema.FechaPrecio;

        console.log(PostServiceM3);
        PostServiceM3.getWithBodyM3('M3Maestro/M3GetProductoBySKU/' + sIDKatios, data).subscribe(resp => {
            var oProducto: any = resp;
            oServiceLoadListaPrecio.AsignarListaPrecio(oProducto, oDataUser, PostServiceM3).then(x => {
                oFuncionOK(oProducto);
            });

        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }


    //rae el producto de acuerdo al SKU
    async M3GetProductoBySKUAsync(PostServiceM3: PostServiceM3, sIDKatios: string, sSKU: string,
        oDataUser: any, Ubicacion: string = "-1", sAplExc: string = "1") {
        var data;
        var resp;
        var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(sIDKatios);

        data = { 'SKU': sSKU, "UBICACION": Ubicacion == "-1" ? oDataUser.UsuarioSistema.UBICACION : Ubicacion, 'AplExc': sAplExc };
        if (oDataUser.UsuarioSistema.FechaPrecio) data.fechaLPrecio = oDataUser.UsuarioSistema.FechaPrecio;

        resp = await PostServiceM3.getWithBodyM3('M3Maestro/M3GetProductoBySKU/' + sIDKatios, data).toPromise();
        await oServiceLoadListaPrecio.AsignarListaPrecio(resp, oDataUser, PostServiceM3);
        return resp;
    }


    //Obtener producto especfico teniendo en cuenta codigo.
    async Get_M3ProductoEspecByCodeAsync(PostServiceM3: PostServiceM3, sIDKatios: string, data: any, oDataUser: any) {
        var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(sIDKatios);
        var oProducto: any;

        if (oDataUser.UsuarioSistema.FechaPrecio) data.fechaLPrecio = oDataUser.UsuarioSistema.FechaPrecio;

        oProducto = await PostServiceM3.getWithBodyM3("M3Maestro/Get_M3ProductoEspecByCode/" + sIDKatios, data).toPromise();
        await oServiceLoadListaPrecio.AsignarListaPrecio(oProducto, oDataUser, PostServiceM3);
        return oProducto;
    }


    //Trae los registros que se encuentren en M3Procesos que se encuentren con estadogeneral proceso
    M3getRegistrosEnProceso(PostServiceM3: PostServiceM3, sIDKatios: string, idProceso: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        var data;
        data = { 'idProceso': idProceso }
        PostServiceM3.getWithBodyM3('M3/get_RegistrosEnProceso/' + sIDKatios, data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(JSON.parse(resp.toString()));
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(err._bSody);
            });
    }

    //Obtiene el top 20 de productos que coincidad con el sNombre ingresado
    get_M3PrdGrpByNombre(PostServiceM3: PostServiceM3, sIDKatios: string, sNombre: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getM3('M3Maestro/get_M3PrdGrpByNombre/' + sIDKatios + '/' + sNombre).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            var jResp = JSON.parse(resp).RESPUESTA.M3GRP;
            if (jResp.length === undefined) {
                resp = new Array(jResp);
                oFuncionOK(resp);
            }
            else {
                oFuncionOK(jResp);
            }
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }//End get_M3PrdGrpByNombre

    //Obtiene el top 20 de productos agrupados que coincidad con el sNombre ingresado
    public GetM3PrdAgrupadoByNombre(PostServiceM3: PostServiceM3, sIDKatios: string, sNombre: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getM3('M3Maestro/get_m3_prd_by_nombre_agrupado/' + sIDKatios + '/' + sNombre).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            var jResp = JSON.parse(resp).RESPUESTA.M3GRP;
            if (jResp.length === undefined) {
                resp = new Array(jResp);
                oFuncionOK(resp);
            }
            else {
                oFuncionOK(jResp);
            }
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }

    //Obtiene el top 20 de productos agrupados que coincidad con el sNombre ingresado y que no esten exlcuidos (M3ExcPrdXUbic)
    public get_m3_prd_by_nombre_agrupado(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        //data = {nombre:'asdasd', idUbicacion:'1'}
        PostServiceM3.getWithBodyM3('M3Maestro/get_m3_prd_by_nombre_agrupado/' + sIDKatios, data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            var jResp = JSON.parse(String(resp)).RESPUESTA.M3GRP;
            if (jResp.length === undefined) {
                resp = new Array(jResp);
                oFuncionOK(resp);
            }
            else {
                oFuncionOK(jResp);
            }
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }

    ///Obtiene el path base donde se encuentra alojadas las imagenes en el servidor
    public get_PathServidorImagenes(PostServiceM3: PostServiceM3, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getM3('M3Maestro/get_PathServidorImagenes/' + sIDKatios).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK

            console.log(resp)
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }//End get_PathServidorImagenes


    //Obtener producto especfico teniendo en cuenta codigo.
    Get_M3ProductoEspecByCode(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function, oDataUser: any) {
        var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(sIDKatios);

        if (oDataUser.UsuarioSistema.FechaPrecio) data.fechaLPrecio = oDataUser.UsuarioSistema.FechaPrecio;
        PostServiceM3.getWithBodyM3("M3Maestro/Get_M3ProductoEspecByCode/" + sIDKatios, data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var oProducto: any = resp;
            oServiceLoadListaPrecio.AsignarListaPrecio(oProducto, oDataUser, PostServiceM3).then(x => {
                oFuncionOK(resp);
            });

        },
            error => {
                console.log(error);
                //Ejecutar funcion de error
                oFuncionErr(error.error.Message);
            });
    }

    Get_M3ProductoEspecByCodeTimeOut(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function, oDataUser: any, timeoutTime: number) {
        var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(sIDKatios);

        if (timeoutTime != 0) {
            if (oDataUser.UsuarioSistema.FechaPrecio) data.fechaLPrecio = oDataUser.UsuarioSistema.FechaPrecio;
            PostServiceM3.getWithBodyM3TimeOut("M3Maestro/Get_M3ProductoEspecByCode/" + sIDKatios, data, timeoutTime).subscribe(resp => {
                //Ejecutar funcion de procesamiento OK
                var oProducto: any = resp;
                oServiceLoadListaPrecio.AsignarListaPrecio(oProducto, oDataUser, PostServiceM3).then(x => {
                    oFuncionOK(resp);
                });

            },
                error => {
                    console.log(error);
                    //Ejecutar funcion de error
                    if (error.error) {
                        oFuncionErr(error.error.Message);
                    }
                    else {
                        oFuncionErr("404");
                    }
                });
        } else {
            oFuncionErr("404");
        }
    }

    get_DocsFromCouchMaestro(oM3CouchMaestro: M3CouchMaestro, sIdKatios: string, sDoc: string, oFuncionOK: Function, oFuncionErr: Function) {
        console.log("get_DocsFromCouchMaestro")
        var sIdKeyDoc = oM3CouchMaestro.GetKeyDocumentoDB(sIdKatios, sDoc);
        console.log(sIdKeyDoc)
        oM3CouchMaestro.GetDataPouchBD(sIdKeyDoc).then(result => {
            oFuncionOK(result);
        }, error => {
            oFuncionErr(error);
        });
    }

    GetProductoEspecByCodeFromCouch(jProductsCouch: any, sCode: string,
        oFuncionOK: Function, oFuncionError: Function) {
        var jProductsFil = jProductsCouch.find(x => x.LoM3PrdGeneral != undefined && x.LoM3PrdGeneral.find(w => w.M3Cods != undefined && w.M3Cods.find(y => String(y.Valor) == String(sCode)) != undefined) != undefined);
        var product_clone = _.cloneDeep(jProductsFil);

        if (jProductsFil != undefined) {
            var jPrdEsp = jProductsFil.LoM3PrdGeneral.find(w => w.M3Cods.find(y => String(y.Valor) == String(sCode)) != undefined)
            product_clone.LoM3PrdGeneral = [];
            product_clone.LoM3PrdGeneral.push(jPrdEsp);
            console.log("product_clone")
            console.log(product_clone)
            oFuncionOK(product_clone)
        }
        else {
            oFuncionError("No se encontrÃ³ nungÃºn registro.");
        }

    }

    ///Obtiene los Tipos de procesos desde el servidor
    public get_TiposProceso(PostServiceM3: PostServiceM3, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function, actividad: string = 'Ventas') {

        PostServiceM3.getM3('M3Maestro/get_TiposProceso/' + sIDKatios + '/' + actividad).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(JSON.parse(resp).RESPUESTA);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err);
            });
    }//End get_TiposProceso

    ///Obtiene la Info de un proceso a partir de un idProceso y un IdM3
    public get_InfoPersona_Proceso(PostServiceM3: PostServiceM3, sIDKatios: string, jData: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getWithBodyM3('M3Maestro/get_InfoPersona_Proceso/' + sIDKatios, jData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(JSON.parse(String(resp)).RESPUESTA);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err);
            });
    }//End get_InfoProceso

    /**
     * Obtiene la Info de un proceso a partir de un idProceso y un IdM3 de manera sincrÃ³nica
     * @param PostServiceM3 
     * @param sIDKatios 
     * @param jData 
     */
    public async get_InfoPersona_Proceso_async(PostServiceM3: PostServiceM3, sIDKatios: string, jData: any) {
        var json;
        var resp;

        try {
            resp = await PostServiceM3.getWithBodyM3('M3Maestro/get_InfoPersona_Proceso/' + sIDKatios, jData).toPromise();
            json = JSON.parse(resp)
            return json;
        }
        catch {
            return null;
        }
    }


    //Obtener un producto agrupado, teniendo una lista de producto agrupados y un sku
    public GetM3PrdGrpFromList(ListPrd: Array<TypeM3PrdGrp>, sku): TypeM3PrdGrp {
        try {
            var oTypeM3PrdGrpResult: TypeM3PrdGrp;
            oTypeM3PrdGrpResult = ListPrd.find(prd => {
                var bResp: boolean = false;
                prd.LoM3PrdGeneral.forEach(prd => {

                    if (prd.SKU === sku) {
                        bResp = true;
                    }
                });
                return bResp;
            });
            oTypeM3PrdGrpResult.LoM3PrdGeneral = oTypeM3PrdGrpResult.LoM3PrdGeneral.filter(gen => gen.SKU == sku);
            return oTypeM3PrdGrpResult;
        } catch (ex) {
            console.log(ex);
            return null;
        }
    }


    ///Obtener de una lista de ubicaciones, una ubicacion en particular, teniendo en cuenta el IdUbicacion
    public GetUbicacionFromList(ListUbic: Array<M3Ubicacion>, sIdUbic) {
        var oM3Ubicacion: M3Ubicacion;
        oM3Ubicacion = ListUbic.find(ubic => ubic.IDUbicacion == sIdUbic);
        return oM3Ubicacion;
    }

    ///Obtiene el Xml de configuracion de la empresa a partir del idubicacion
    public get_XmlConfig_x_IdUbicacion(PostServiceM3: PostServiceM3, sIDKatios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getWithBodyM3('M3Maestro/get_XmlConfig_x_IdUbicacion/' + sIDKatios, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(JSON.parse(resp.toString()));
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err);
            });
    }//End get_XmlConfig_x_IdUbicacion

    ///Obtiene los atributos en m3clasifica a partir de un idkatios
    get_clasification_attributes(PostServiceM3: PostServiceM3, id_katios: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/get_clasification_attributes/' + id_katios).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var jResp = JSON.parse(resp).RESPUESTA.ATTRIBUTES;
            if (jResp.length === undefined) {
                jResp = new Array(jResp);
            }

            oFuncionOK(jResp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }



    ///Obtiene las categorias en m3clasifica a partir de un idkatios y un atributo
    get_clasification_categories(PostServiceM3: PostServiceM3, id_katios: string, attribute: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/get_clasification_categories/' + id_katios + "/" + attribute).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var jResp = JSON.parse(resp).RESPUESTA.CATEGORIES;
            if (jResp.length === undefined) {
                jResp = new Array(jResp);
            }

            oFuncionOK(jResp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr();
            });
    }

    getOpcionesAdicionales(PostServiceM3: PostServiceM3, id_katios: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/getOpcionesAdicionales/' + id_katios).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var jResp = JSON.parse(resp).RESPUESTA.ATTRIBUTES;
            if (jResp.length === undefined) {
                jResp = new Array(jResp);
            }

            oFuncionOK(jResp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }

    getAtributosAdicionales(PostServiceM3: PostServiceM3, id_katios: string, attribute: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/getAtributosAdicionales/' + id_katios + "/" + attribute).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var jResp = JSON.parse(resp).RESPUESTA.CATEGORIES;
            if (jResp.length === undefined) {
                jResp = new Array(jResp);
            }

            oFuncionOK(jResp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }


    ///Obtiene la informacion de tipos de envio.
    M3GetFormasEnvio(PostServiceM3: PostServiceM3, id_katios: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/M3GetFormasEnvio/' + id_katios).subscribe(resp => {
            var jsResp;
            jsResp = JSON.parse(resp);
            oFuncionOK(jsResp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr();
            });
    }

    ///Obtinie todas las M3Ubicaciones asociadas a un id_katios
    public get_ubicaciones_complete(PostServiceM3: PostServiceM3, id_katios: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/get_ubicaciones_complete/' + id_katios).subscribe(resp => {
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr();
            });
    }


    ///Obtinie todas las M3Ubicaciones asociadas a un id_katios
    public async M3GET_LISTAPRECIOS_ASync(PostServiceM3: PostServiceM3, id_katios: string) {
        var oRecListaPrec: any;

        oRecListaPrec = await PostServiceM3.getM3('M3Maestro/M3GET_LISTAPRECIOS/' + id_katios).toPromise();
        return oRecListaPrec[0];
    }

    public async GetEncabezadoListasPrecio(PostServiceM3: PostServiceM3, sIDKatios: string) {
        var resp;

        try {
            resp = await PostServiceM3.getM3('M3/GetConfigLP/' + sIDKatios).toPromise();
            return resp;
        }
        catch {
            return null;
        }
    }

    public registrarColonia(PostServiceM3: PostServiceM3, IdKatios: string, sColonia: string, sCodPostal, sTelefono: string, ndoc: string, sLinea1: string, sCodestado: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        var oDataSend;
        oDataSend = { "sColonia": sColonia, "sCodPostal": sCodPostal, "sTelefono": sTelefono, "ndoc": ndoc, "sLinea1": sLinea1, "sCodestado": sCodestado };
        PostServiceM3.postServiceHttpResFullM3('M3Maestro/registrarColonia/' + IdKatios, oDataSend).subscribe(posts => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK();
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(JSON.parse(err._body).Message);
            });

    }

    ///Obtener promociones 
    public async M3_GetPromocionesMaestroAsync(PostServiceM3: PostServiceM3, id_katios: string) {
        var oRecListaPrec: any;

        oRecListaPrec = await PostServiceM3.getM3('M3Maestro/M3_GetPromocionesMaestro/' + id_katios).toPromise();
        return oRecListaPrec;
    }


    ///Obtener Dinamicas por actividad 
    public async M3GetDinByActividad(PostServiceM3: PostServiceM3, id_katios: string, oData: any, oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getWithBodyM3('M3Maestro/M3GetDinByActividad/' + id_katios, oData).subscribe(resp => {
            //var jsResp:any = resp;
            //jsResp = JSON.parse(jsResp);
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr();
            });


        // var oRecListaPrec: any;

        // oRecListaPrec = await PostServiceM3.getWithBodyM3('M3Maestro/M3GetDinByActividad/' + id_katios, oData).toPromise();
        // return oRecListaPrec;
    }

    /**
     * Retorna la info basica de las ubicaciones con Hub tipo WEB activos en el momento
     * @param PostServiceM3 
     * @param idKatios 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    getUbicacionesWeb(PostServiceM3: PostServiceM3, idKatios: string, oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3Maestro/getUbicacionesWeb/' + idKatios).subscribe(resp => {
            oFuncionOK(JSON.parse(resp));
        },
            err => {
                oFuncionErr(err);
            });
    }

    /**
     *  Retorna la info basica de las ubicaciones con Hub tipo WEB activos en el momento que abarquen un codpostal en concreto
     * @param PostServiceM3 
     * @param idKatios 
     * @param data 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    getUbicacionesByCodPostal(PostServiceM3: PostServiceM3, idKatios: string, data: any, oFuncionOK: Function, oFuncionErr: Function) {
        //data = { "codPostal": string };
        PostServiceM3.getWithBodyM3('M3Maestro/getUbicacionesByCodPostal/' + idKatios, data).subscribe(resp => {
            oFuncionOK(JSON.parse(resp.toString()));
        },
            err => {
                oFuncionErr(err);
            });
    }

    /**
     * Retorna el path de la factura electrÃ³nica a partir de un IdDiario asociado al proceso 
     * @param PostServiceM3 
     * @param idKatios 
     * @param data 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public getPathFEFromDiario(PostServiceM3: PostServiceM3, idKatios: string, tipoGeneracion: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3/getPathFEFromDiario/' + idKatios + '/' + tipoGeneracion, data).subscribe(resp => {
            var respuesta: any = JSON.parse(resp.toString());
            oFuncionOK(respuesta);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(err);
            });
    }

    public getDiarioAdicionalesxDiario(PostServiceM3: PostServiceM3, idKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyGenerales('Diario/getDiarioAdicionalesxDiario/' + idKatios, data).subscribe(resp => {
            var respuesta: any = JSON.parse(resp.toString());
            oFuncionOK(respuesta);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }


    async IU_Hub(PostServiceM3: PostServiceM3, id_katios: string, oHub: any, uTActivo: string, uNActivo: string) {
        var Info;
        var data = { 'idKatios': id_katios.trim(), 'oHub': oHub, 'uTActivo': uTActivo, 'uNActivo': uNActivo };
        Info = await PostServiceM3.postServiceHttpResFullM3('M3Maestro/IU_Hub', data).toPromise()
        return Info
    }



    /**
     * Obtener el ctivo desde servidor
     * @param PostServiceM3 
     * @param id_katios 
     * @param idproceso 
     * @param ubicacion 
     * @param hub 
     */
    async GetCtivoBYProceso(PostServiceM3: PostServiceM3, id_katios: string, idproceso: string, ubicacion: string, hub: string) {
        var Info;
        var data = { 'idproceso': idproceso, 'ubicacion': ubicacion, 'hub': hub };
        Info = await PostServiceM3.getWithBodyM3('M3/GetCtivoBYProceso/' + id_katios.trim(), data).toPromise()
        return Info
    }


    public async ValidarCtivosVSLocal(PostServiceM3: PostServiceM3, id_katios: string,
        infProceso: string, ubicacion: string, hub: string, funcionResp: Function) {
        PostServiceM3.postServiceHttpResFullM3('M3/ValidarCtivosVSLocal/' + id_katios + '/' + ubicacion + '/' + hub, infProceso).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            funcionResp(resp);
        },
            error => {
                //Ejecutar funcion de error
                funcionResp({ "error": error });
            });
    }

    async GenerarAutorizacionCuentas(PostServiceM3: PostServiceM3, data) {
        var Info;

        Info = await PostServiceM3.postServiceHttpResFullM3('M3/GenerarAutorizacionCuentas', data).toPromise()
        return Info
    }

    /**
     * Valida si el codigo ingresado corresponde al documento y si el codigo esta en estado activo
     * @param PostServiceM3 
     * @param data 
     */
    async validacionAutorizacionM3Cuentas(PostServiceM3: PostServiceM3, data) {
        var Info;

        Info = await PostServiceM3.postServiceHttpResFullM3('M3/validacionAutorizacionM3Cuentas', data).toPromise()
        return Info
    }


    async VerificarPagoTarjetaBBVA(PostServiceM3: PostServiceM3, sIDKatios: string, sIdKey: string) {
        var jData = { "Idkatios": sIDKatios, "idKey": sIdKey }
        var Info;
        Info = await PostServiceM3.getWithBodyM3('M3/VerificarPagoTarjetaBBVA', jData).toPromise()
        return Info;
    }//End get_InfoProceso

    /**
     * FS 20190813: Retorna los codigos de los SKP(skpToFind) y su respectivo significado para un producto dado
     * @param idKatios 
     * @param PostServiceM3 
     * @param data 
     * @param funcionOK 
     * @param funcionError 
     */
    public getDescripcionSKPs(idKatios: string, PostServiceM3: PostServiceM3,
        data: any, funcionOK: Function, funcionError: Function) {

        //let data = {"SKP1":"SKP1", SKPToFind: 2 }};

        PostServiceM3.getWithBodyM3("M3Consultas/getDescripcionSKPs/" + idKatios, data).subscribe(resp => {
            funcionOK(data.SKP1, JSON.parse(resp.toString()));
        },
            err => {
                funcionError(err.error.Message);
            });
    }


    async getTotalesCierreCaja(postService: PostServiceM3, sIdKatios: string, subicacion: string, shub: string, susuario: string, sFechaI: string, sFechaF: string) {
        var secopciones: any;
        var data = { 'idKatios': sIdKatios, 'ubicacion': subicacion, 'hub': shub, 'usuario': susuario, 'FechaI': sFechaI, 'FechaF': sFechaF }
        secopciones = await postService.getWithBodyM3('M3/getTotalesCierreCaja', data).toPromise()
        secopciones = JSON.parse(secopciones)
        return secopciones
    }

    async getCierresxUbicacion(postService: PostServiceM3, sIdKatios: string, subicacion: string, sIdProceso: string, sFecha: string) {
        var secopciones: any;
        var data = { 'idKatios': sIdKatios, 'ubicacion': subicacion, 'idProceso': sIdProceso, 'Fecha': sFecha }
        secopciones = await postService.getWithBodyM3('M3/getCierresxUbicacion', data).toPromise()
        secopciones = JSON.parse(secopciones)
        return secopciones
    }

    async getCierresxEmpresa(postService: PostServiceM3, sIdKatios: string, sIdProceso: string, sFecha: string) {
        var secopciones: any;
        var data = { 'idKatios': sIdKatios, 'idProceso': sIdProceso, 'Fecha': sFecha }
        secopciones = await postService.getWithBodyM3('M3/getCierresxEmpresa', data).toPromise()
        secopciones = JSON.parse(secopciones)
        return secopciones
    }

    //Trae el m3procesos segpun el idprestamo
    public simularpagoEnlinea(PostServiceM3: PostServiceM3, sIDKatios: string, sIdM3: string, sIdProceso: string,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getM3('M3/ValidacionPagoIntegracionTest/' + sIDKatios + '/' + sIdM3 + '/' + sIdProceso).subscribe(resp => {
            oFuncionOK();
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr();
            });
    }

    public validarPrdsMismoProveedor(PostServiceM3: PostServiceM3, id_katios: string, nombreAdicionalProveedor: string, oM3Procesos: M3Procesos, oFuncionResp: Function) {
        PostServiceM3.postServiceHttpResFullM3("M3Maestro/validarPrdsMismoProveedor/" + id_katios + "/" + nombreAdicionalProveedor, oM3Procesos).subscribe(resp => {
            oFuncionResp(JSON.parse(JSON.parse(resp['_body']).toString()))
        },
            err => {
                //Ejecutar funcion de error        
                console.error("Error validarPrdsMismoProveedor")
                console.error(err)
                oFuncionResp(JSON.parse(JSON.parse(err['_body']).Message));
            });
    }

    public validarRestriccionInvNegativo(PostServiceM3: PostServiceM3, id_katios: string, oM3Procesos: M3Procesos, oFuncionResp: Function) {
        PostServiceM3.postServiceHttpResFullM3("M3Maestro/validarRestriccionInvNegativo/" + id_katios, oM3Procesos).subscribe(resp => {
            oFuncionResp(JSON.parse(JSON.parse(resp['_body']).toString()))
        },
            err => {
                //Ejecutar funcion de error        
                console.error("Error validarRestriccionInvNegativo")
                console.error(err)
                oFuncionResp(JSON.parse(JSON.parse(err['_body']).Message));
            });
    }

    public async getInfoPrdGastosEnvio(PostServiceM3: PostServiceM3, id_katios: string, oM3Procesos: M3Procesos) {

        let resp = await PostServiceM3.postServiceHttpResFullM3("M3Maestro/getInfoPrdGastosEnvio/" + id_katios, oM3Procesos).toPromise();
        return JSON.parse(JSON.parse(resp['_body']).toString()).RESPUESTA
    }

    /**
     * Genera una saldoxcuenta aleatorio por el valor dado
     * @param PostServiceM3 
     * @param idkatios 
     * @param data = {"proceso",proceso,"valor":valor,"nombreDoc": nombreDoc}
     */
    public async m3_generar_M3SXC_aleatorio(PostServiceM3: PostServiceM3, idkatios: string, data: any) {

        try {
            let resp = await PostServiceM3.postServiceHttpResFullM3("M3/m3_generar_M3SXC_aleatorio/" + idkatios, data).toPromise();
            return JSON.parse(JSON.parse(resp['_body']).toString()).RESPUESTA;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }

}
